import styled from "styled-components";
import { zIndex } from "../../constants";

export const Legend = styled.div`
  position: absolute;
  z-index: ${zIndex.legendToggle};
  /* Anchored above the key toggle rather than tied to the bottom of the
     whole button column, so it grows upward from a fixed point clear of
     any bottom view-toggle row (e.g. StatesMap's) instead of drifting
     down with the column and crowding it. */
  bottom: 100px;
  left: 71px;
  color: var(--color-primary);
  border-radius: 8px;
  background: rgba(255,255,255,0.9);
  padding: 10px;
  transform-origin: bottom left;
  transition: opacity 0.18s ease-out, transform 0.18s ease-out;
  opacity: ${(props) => (props.$open ? 1 : 0)};
  transform: ${(props) => (props.$open ? "scale(1)" : "scale(0.85)")};
  visibility: ${(props) => (props.$open ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.$open ? "auto" : "none")};

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    font-size: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (min-width: 640px) {
    bottom: 10px;
    left: auto;
    right: 10px;
    transform: none;
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
`;

export const LegendHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export const LegendTitle = styled.div`
  font-size: 16px;
  font-family: var(--font-primary);
  font-weight: 700;
  color: var(--color-primary);
  margin-bottom: 10px;
`;

// Only meaningful on mobile, where the legend is a dismissible panel behind
// the key toggle; on desktop it's shown inline at all times, so the close
// control would just be a dead end with no way back.
export const LegendCloseButton = styled.button`
  flex: none;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -2px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: none;
  color: var(--color-primary);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.08);
  }

  @media (min-width: 640px) {
    display: none;
  }
`;

export const LegendSwatch = styled.div`
  height: 15px;
  width: 15px;
  margin-right: 10px;
  border-radius: 3px;
  background: ${(props) => props.color};
  border: ${(props) => props.border || "none"};
`;